import { DiCssdeck } from "react-icons/di";
import { BrowserRouter } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import { SocialIcon } from "react-social-icons";

function NavBar() {
  return (
    <BrowserRouter>
      <div id="home">
        <nav class="relative container mx-auto p-6">
          <div class="grid grid-cols-2 md:flex justify-around ">
            <Link to="home" class="flex">
              <DiCssdeck size="1.5rem" />
              <span class="font-bold">Portfolio</span>
            </Link>

            <div class="hidden md:inline-block space-x-6">
              <Link to="#projects" smooth>
                <a>Projects</a>
              </Link>
              <Link to="#technologies" smooth>
                <a>Technologies</a>
              </Link>
              <Link to="#timeline" smooth>
                <a>About</a>
              </Link>
            </div>

            <div class="flex space-x-6 justify-end">
              <SocialIcon
                url="https://github.com/sangwaniKondowe"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
              <SocialIcon
                url="https://linkedin.com/in/sangwani-kondowe-624408200"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
              <SocialIcon
                url="https://twitter.com/SangwaniKondowe"
                target="_blank"
                fgColor="#fff"
                class="transform hover:scale-110 transition ease-out duration-300"
                style={{ height: 30, width: 30 }}
              />
            </div>
          </div>
        </nav>
      </div>
    </BrowserRouter>
  );
}

export default NavBar;
